/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Dry_RunInputs */

const cs_sklik_dry_run = /** @type {(inputs: Sklik_Dry_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry run (jen mapování/log, bez živých zápisů)`)
};

const en_sklik_dry_run = /** @type {(inputs: Sklik_Dry_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry run (map/log only, no live API writes)`)
};

/**
* | output |
* | --- |
* | "Dry run (map/log only, no live API writes)" |
*
* @param {Sklik_Dry_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_dry_run = /** @type {((inputs?: Sklik_Dry_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Dry_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_dry_run(inputs)
	return cs_sklik_dry_run(inputs)
});